<template>
  <div class="card">
    <Datatable
      tableId="jobTemplatesTable"
      uniqueField="name"
      :columns="columns"
      :data="jobTemplates"
      :compact="true"
      :orderColumn="orderColumn"
      :formatColumn="formatColumn"
      :detailColumn="{
        baseUrl: 'job-templates/',
        identifier: 'name',
        identifierName: 'name',
        name: 'Template Job',
      }"
    />
  </div>
</template>

<script>
import Datatable from "../../components/Datatable.vue";
import { secondsTohms } from '../../utils/commonFunction';

export default {
  name: "JobTemplates",
  components: { Datatable },
  data() {
    return {
      columns: [
        { data: "name" },
        { data: "kind" },
        {
            data: "last_run_started_at", 
            title: "Last Run At"
          },               
          {
            data: "last_run_time", 
            title: "Last Run Time",
            render: function (data, type, row) {
              return secondsTohms(data)
            },
          },
          {
            data: "last_run_status", 
            title: "Last Run Status"
          },
          { data: "meters", title:"is metered",
                    render: function (data, type, row) {
                      return data?.length? "Yes": "No";
						},
					},
        { data: "created_by", title: "Created by" },
        { data: "created_at", title: "Created at" },
      ],
      orderColumn: [3, "desc"],
      //Note: index - table column index which need to formatted
      formatColumn: [
        {
          index: 3,
          type: "datetime",
        },
        {
          index: 8,
          type: "datetime",
        },
      ],
      loading: false,
    };
  },
  computed: {
    jobTemplates() {
      let jobList=[];
      this.$store.state.amdp.templateJobs.map((job)=>{
        let status = job.last_run_status?job.last_run_status.toLowerCase():'';
        let statusStr = job.last_run_status;
        if(status==="succeeded" || status==="completed"){
          statusStr = "<span class='text-success'>●</span> "+job.last_run_status;
        } else if(status==="failed"){
          statusStr = "<span class='text-danger'>●</span> "+job.last_run_status;
        } else if(status==="running"){
          statusStr = "<span class='text-primary'>●</span> "+job.last_run_status;
        } else if(status==="submitted"){
          statusStr = "<span class='text-warning'>●</span> "+job.last_run_status;
        } else if(status==="cancelled"){
          statusStr = "<span class='text-secondary'>●</span> "+job.last_run_status;
        }
        job["last_run_status"] = statusStr;
        jobList.push(job);
      })
      return jobList;
      }
  },
  beforeMount() {
    this.$store.dispatch("amdp/fetchTemplateJobs");
  }
};
</script>

<style scoped></style>
